import { Button, Typography } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import AddIcon from '@material-ui/icons/Add';

import type { CreationEntryState } from './usePortfolioAccess';

/**
 * Entrada de criação de atividade. Existe uma única implementação para que as
 * duas entradas da página — cabeçalho e estado vazio — não possam divergir, e
 * para que a distinção entre "você não pode" e "não foi possível verificar" seja
 * a mesma nas duas.
 *
 * - `allowed`: botão acionável.
 * - `absent`: sem permissão em projeto algum; a entrada não é renderizada, e o
 *   portfólio segue legível sem erro.
 * - `pending` e `unavailable`: indeterminação. A criação não é liberada e o
 *   motivo é dito — nunca liberação silenciosa (ADR-002).
 */
export const PortfolioCreationEntry = ({
  state,
  onCreate,
  onRetry,
}: {
  state: CreationEntryState;
  onCreate: () => void;
  onRetry: () => void;
}) => {
  if (state === 'absent') return null;

  const supportId = 'creation-entry-support';
  return (
    <>
      <Button
        variant="contained"
        color="primary"
        startIcon={<AddIcon />}
        onClick={onCreate}
        disabled={state !== 'allowed'}
        aria-describedby={state === 'allowed' ? undefined : supportId}
      >
        Nova Atividade
      </Button>
      {state === 'pending' && (
        <Typography id={supportId} variant="caption" component="span">
          Confirmando permissões...
        </Typography>
      )}
      {state === 'unavailable' && (
        <Alert
          id={supportId}
          severity="warning"
          action={
            <Button color="inherit" size="small" onClick={onRetry}>
              Tentar novamente
            </Button>
          }
        >
          Não foi possível confirmar suas permissões agora. A criação de
          atividades fica indisponível até a confirmação.
        </Alert>
      )}
    </>
  );
};
